import { getReportJob } from './getReportJob';

export type ReportJobStatus = 'queued' | 'running' | 'done' | 'failed';

// Uma etapa aberta (`finishedAt` nulo) é a que está acontecendo agora; as fechadas já têm
// duração. É o que permite a tela mostrar o que o servidor está fazendo neste instante em
// vez de um spinner mudo por dez minutos.
export type EtapaRelatorio = {
    label: string;
    startedAt: string;
    finishedAt: string | null;
};

export type ReportJob = {
    id: string;
    type: string;
    status: ReportJobStatus;
    report: string | null;
    result: any;
    error: string | null;
    // Instante do clique, gravado quando o job nasce. O `startedAt` abaixo e outra coisa:
    // e quando o calculo comeca de fato, e em modo container ele so e escrito la dentro da
    // task - fica nulo durante todo o provisionamento do Fargate.
    createdAt: string;
    startedAt: string | null;
    finishedAt: string | null;
    etapas: EtapaRelatorio[];
};

// O relatório leva minutos. Enquanto ele era gerado dentro da própria requisição, três
// timeouts a cortavam no meio — o do ALB, o `server.requestTimeout` do Node e o do
// navegador — e o usuário via um erro mesmo com o servidor ainda trabalhando. Consultar o
// job resolve isso na raiz: nenhuma requisição dura mais que milissegundos.
const INTERVALO_MS = 3000;

// Uma consulta que falha não significa relatório perdido: o processamento continua no
// servidor. Só desistimos depois de várias falhas seguidas, para não transformar uma
// oscilação de rede em erro na tela.
const FALHAS_SEGUIDAS_ATE_DESISTIR = 5;

// Distingue "o relatório falhou" de "a consulta falhou". Só a primeira é definitiva.
export class ReportJobFailure extends Error {}

// `onAtualizar` recebe cada leitura bem-sucedida do job. É por ele que as etapas chegam à
// tela: o progresso pega carona nesta consulta que já existia, sem conexão persistente.
export async function waitReportJob(jobId: string, onAtualizar?: (job: ReportJob) => void): Promise<ReportJob> {
    let falhasSeguidas = 0;

    for(;;) {
        try {
            const job = await getReportJob(jobId) as unknown as ReportJob;
            falhasSeguidas = 0;

            onAtualizar?.(job);

            if(job.status === 'done') return job;
            if(job.status === 'failed') throw new ReportJobFailure(job.error || 'O relatório falhou');
        } catch(error: any) {
            if(error instanceof ReportJobFailure) throw error;
            if(++falhasSeguidas >= FALHAS_SEGUIDAS_ATE_DESISTIR) throw error;
        }

        await new Promise(resolve => setTimeout(resolve, INTERVALO_MS));
    }
}
